module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/as1509-28eb1d9f984d8f684b3135919c766389.jpg";